import BaseViewController from "./base-view-controller";
import { DermTreatmentHeader } from "../utils/constants";
import extractFieldValues from "../utils/extract-field-values";

class AddTreatmentViewController extends BaseViewController {
  prepareSubmit(values) {
    const initialValues = extractFieldValues(
      this.screen,
      {},
      this.appData.data
    );
    const dataToUpdate = this.prepareDataToUpdate(values);
    if (this.appData.treatmentToEditData.name) {
      this.appData.updateTreatmentData({
        data: dataToUpdate,
        index: this.appData.treatmentToEditData.index
      });
      this.appData.resetTreatmentToEdit();
    } else {
      this.appData.setTreatmentData(dataToUpdate);
    }

    return {
      ...values,
      term: "",
      ...initialValues
    };
  }

  prepareDataToUpdate(values) {
    const dataToUpdate = {};
    let surveyName = "";
    switch (values.derm_type) {
      case "ACNE_ROSACEA":
        surveyName = DermTreatmentHeader[0].slice(0, -1);
        break;
      case "MOLE":
        surveyName = DermTreatmentHeader[2].slice(0, -1);
        break;
      default:
        surveyName = DermTreatmentHeader[1].slice(0, -1);
        break;
    }
    dataToUpdate[`${surveyName}1`] = values.term;
    for (let i = 2; i < 7; i++) {
      if (!values[`${surveyName}${i}`]) {
        dataToUpdate[`${surveyName}${i}`] = "";
      } else {
        dataToUpdate[`${surveyName}${i}`] = values[`${surveyName}${i}`];
      }
    }

    return dataToUpdate;
  }
}

export default AddTreatmentViewController;
